// extracted by mini-css-extract-plugin
module.exports = {"title":"Hero_title__p4fGf"};